export const BUTTON_SIZES = ['large', 'medium', 'small', 'none'] as const;
export type ButtonSize = (typeof BUTTON_SIZES)[number];
